import {useRpcSender} from "../RpcSender";
import {useState} from "react";
import {RpcState} from "../RpcState";
import {com, space} from "../../provider_api";
import IApiPaymentProto = space.kenko.proto.IApiPaymentProto;
import IGetStripePaymentsRequest = com.onkensu.platform.billing.IGetStripePaymentsRequest;
import GetStripePaymentsRequest = com.onkensu.platform.billing.GetStripePaymentsRequest;
import GetStripePaymentsResponse = com.onkensu.platform.billing.GetStripePaymentsResponse;

export const useGetStripePayments = () => {
  
  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'pending'});
  const [payments, setPayments] = useState<IApiPaymentProto[]>();
  
  const send = (request: IGetStripePaymentsRequest) => {

    setRpcState({state: 'pending'});
    rpcSender.send("get_stripe_payments", GetStripePaymentsRequest.encode(request).finish())
        .then(bytes => {
          const response = GetStripePaymentsResponse.decode(bytes);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'Error loading transactions'})
            return;
          }

          setPayments(response.payment);
          setRpcState({state: 'success'});
        })
        .catch(e => {
          console.log(e);
          setRpcState({state: 'error', message: 'Network error loading transactions: ' + e})
        })
  }
  
  return {rpcState, payments, send};
}
